import React, { BaseSyntheticEvent, useEffect, useState } from "react";
import { OrganisationType } from "../../../../_App/Types/Entites/OrganisationType";
import styled from "styled-components";
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { AffectationMenuDataType } from "../../../../_App/Types/Forms/AppMenus/AffectationMenuDataType";
import _ from "lodash";

const StyledOrg = styled.div`
  height: 100% !important;

  .clearboth {
    clear: both;
    margin-top: -5px;
  }
  .component-card_1,
  .col-org {
    height: 95%!important;
    margin-bottom:15px;
  }
  .user-ligne {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30px;
    padding: 5px;
    border-radius: 15px;
    cursor: pointer;
  }
  .card-body {
    padding-top: 15px;
  }
  .user-ligne:hover {
    background: #bdfdc4;
    border-radius: 15px;
  }
  .user-name {
    width: 150px;
  }
  .user-role,
  .user-role > span {
    width: 100px;
    font-weight: 400 !important;
  }
`;
const OrganisationItemMenu = ({
  organisation,
  register,
  getValues,
  setValue,
}: {
  organisation: OrganisationType;
  register: UseFormRegister<AffectationMenuDataType>;
  getValues: UseFormGetValues<AffectationMenuDataType>;
  setValue: UseFormSetValue<AffectationMenuDataType>;
}) => {


    const [checkOrganisation, setcheckOrganisation] = useState<boolean>(false);

    

    /**
     * @desc check or uncheck user 
     * @param organisation_id string
     * @param user_id string
     */
  const onCheckUser = (organisation_id: string, user_id: string) => {
    
    const currentValue = getValues(`organisations.${organisation_id}.${user_id}`);

    if (_.isUndefined(currentValue) || currentValue== false) {
      setValue(`organisations.${organisation_id}.${user_id}`, true);
    } else {
      setValue(`organisations.${organisation_id}.${user_id}`, false);
    }
  };

  
    /**
     * @desc check or uncheck user 
     * @param organisation_id string
     * @param user_id string
     */
    const onCheckOrganisation = (organisation_id: string) => {
    
        const organisation = getValues(`organisations.${organisation_id}`);

        _.each(organisation, (check : boolean, user_id: string) => {
            if(checkOrganisation) {
                setValue(`organisations.${organisation_id}.${user_id}`, false);  
            }else{
                setValue(`organisations.${organisation_id}.${user_id}`, true);  
            }
        })
    
      };

  return (
    <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-3 col-org">
      <StyledOrg>
        <div className={`card component-card_1 relative`}>
          <div className="card-body">
            <div className="user-ligne" onClick={()=> {
                setcheckOrganisation(!checkOrganisation);
                onCheckOrganisation(organisation._id);
            }}>
              <div className="user-name">
                <div
                  className="text-center c-primary float-left"
                  style={{ fontSize: "21px" }}
                >
                  {organisation.nom}
                </div>
              </div>
              <div className="user-role">
                <span className="badge bg-success">{organisation.type}</span>
              </div>
              <div className="user-check">
                <input type="checkbox" checked={checkOrganisation}  
                        onChange={(e : BaseSyntheticEvent)=> {
                            setcheckOrganisation(e.target.value);
                            onCheckOrganisation(organisation._id);
                        }}/>
              </div>
            </div>
            <div className="clearboth">
              <hr />
            </div>
            {organisation.users &&
              organisation.users.map((user: any, indexUs: number) => (
                <div
                  className="user-ligne"
                  key={indexUs}
                  onClick={(e) => onCheckUser(organisation._id, user._id)}
                >
                  <div className="user-name">
                    {user.nom} {user.prenom}
                  </div>
                  <div className="user-role">
                    <span className="badge bg-primary">
                      {user.role.libelle}
                    </span>
                  </div>
                  <div className="user-check">
                    <input
                      type="checkbox"
                      {...register(
                        `organisations.${organisation._id}.${user._id}`
                      )}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </StyledOrg>
    </div>
  );
};

export default OrganisationItemMenu;
